import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  // Classe crucial para forçar o grid de DNA a ocupar a largura inteira do cartão! 🧬⚡
  dnaFormContainer: {
    gridColumn: '1 / -1', // Estende-se por todas as colunas do Grid Tabular!
    marginTop: theme.spacing(1),
  },
  singleLineValue: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    minWidth: 0,
    display: 'block',
    width: '100%',
  },
}))

export default useStyles
